import { render, staticRenderFns } from "./SearchSettings.vue?vue&type=template&id=3fbf8014&scoped=true"
import script from "./SearchSettings.vue?vue&type=script&lang=js"
export * from "./SearchSettings.vue?vue&type=script&lang=js"
import style0 from "./SearchSettings.vue?vue&type=style&index=0&id=3fbf8014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf8014",
  null
  
)

export default component.exports